module.exports = __webpack_public_path__ + "static/sizzle_desktop-c6fe409857e917a8fd9e6e9ce33129ca.mp4";